import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { config } from '../../config/config';
import { showToast } from '../../components/utils/Toast';

// Fetch documents for a project
export const fetchProjectDocuments = createAsyncThunk(
  'projectDocuments/fetchProjectDocuments',
  async (projectId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${config.apiUrl}/api/projects/${projectId}/documents`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      const data = await response.json();
      
      if (!response.ok) {
        return rejectWithValue(data.message || 'Failed to fetch documents');
      }

      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Network error occurred');
    }
  }
);

// Upload project document
export const uploadProjectDocument = createAsyncThunk(
  'projectDocuments/uploadProjectDocument',
  async ({ projectId, file }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('token');
      const formData = new FormData();
      formData.append('file', file);

      const response = await fetch(`${config.apiUrl}/api/projects/${projectId}/documents`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: formData
      });

      const data = await response.json();
      
      if (!response.ok) {
        return rejectWithValue(data.message || 'Failed to upload document');
      }

      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Network error occurred');
    }
  }
);

const projectDocumentsSlice = createSlice({
  name: 'projectDocuments',
  initialState: {
    documents: [],
    loading: false,
    uploading: false,
    error: null
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectDocuments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjectDocuments.fulfilled, (state, action) => {
        state.loading = false;
        state.documents = action.payload.documents;
      })
      .addCase(fetchProjectDocuments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        showToast(action.payload, 'error');
      })
      .addCase(uploadProjectDocument.pending, (state) => {
        state.uploading = true;
        state.error = null;
      })
      .addCase(uploadProjectDocument.fulfilled, (state, action) => {
        state.uploading = false;
        // Add the new document to the documents array
        if (action.payload.document) {
          state.documents = [...state.documents, action.payload.document];
        }
        showToast('Document uploaded successfully', 'success');
      })
      .addCase(uploadProjectDocument.rejected, (state, action) => {
        state.uploading = false;
        state.error = action.payload;
        showToast(action.payload || 'Failed to upload document', 'error');
      });
  }
});

export const { clearError } = projectDocumentsSlice.actions;
export default projectDocumentsSlice.reducer; 